export default {"src":"/_next/static/media/saillogo.30c578db.svg","height":28,"width":120,"blurWidth":0,"blurHeight":0};